import { render } from "./page_03.vue?vue&type=template&id=99601ad2"
import script from "./page_03.vue?vue&type=script&lang=js"
export * from "./page_03.vue?vue&type=script&lang=js"
script.render = render

export default script